function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.66 8.04c0 .23-.06.47-.21.66l-9.38 11.94c-.34.43-.74.58-1.08.46L10 21l1-11 9.04-1.81.62-.15z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.66 8.04l-.62.15L11 10l5.95-5.95c.12.05.22.12.29.19l3.13 3.13c.18.18.28.42.29.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.95 4.05L11 10 3.01 2.9l-.35-.34v-.01c.2-.26.56-.39 1.04-.32l12.96 1.73c.09.01.19.04.29.09z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M11 10l-1 11-.01.1c-.25-.09-.48-.33-.63-.71L2.64 3.59c-.17-.42-.15-.78.02-1.03l.35.34L11 10z"
})));